import { Injectable } from '@angular/core';
import { Firestore, doc, getDoc, getFirestore } from 'firebase/firestore';

import { FIRESTORE_COLLECTIONS } from '../../constants/firebase.constants';
import { FirebaseAppService } from './firebase-app.service';

export interface UsuarioAdminDoc {
  activo?: boolean;
  mail?: string;
  idplataforma?: string;
  idsplataformas?: string | string[];
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseProfileService {
  private readonly firestore: Firestore;

  constructor(firebaseAppService: FirebaseAppService) {
    this.firestore = getFirestore(firebaseAppService.getApp());
  }

  async getUsuarioAdmin(uid: string): Promise<UsuarioAdminDoc | null> {
    const ref = doc(this.firestore, FIRESTORE_COLLECTIONS.usuariosAdmin, uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      return null;
    }

    return snap.data() as UsuarioAdminDoc;
  }
}

